export type ExporContent =
  | 'STATIC_EVENTS'
  | 'PROVERBS'
  | 'QUIZZ'
  | 'DICTATION'
  | 'IMAGE'
  | 'OFFER_MATERIALS'
  | 'DEPLOY_LIGHT'
  | 'OFFER_SETTINGS';
